import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Empresa do futuro",
          "Sistemas inteligentes",
          "E-commerce",
          "Tecnologia de ponta",
          "Gestão completa",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
